import type { RootState } from '@/store';

import type { FaturaStatus, FaturaTipoGeracao } from '../types';

export const selectFaturas = (state: RootState) => state.faturas.faturas;
export const selectFaturasLoading = (state: RootState) => state.faturas.loading;
export const selectFaturasSaving = (state: RootState) => state.faturas.saving;
export const selectFaturasError = (state: RootState) => state.faturas.error;
export const selectFaturasSummary = (state: RootState) => state.faturas.summary;
export const selectFaturasFilters = (state: RootState) => state.faturas.filters;

export const selectFaturaById = (id: string) => (state: RootState) =>
  state.faturas.faturas.find((f) => f.id === id) ?? null;

export const selectFaturasByStatus = (status: FaturaStatus) => (state: RootState) =>
  state.faturas.faturas.filter((f) => f.status === status);

export const selectFaturasByTipoGeracao = (tipo: FaturaTipoGeracao) => (state: RootState) =>
  state.faturas.faturas.filter((f) => f.tipoGeracao === tipo);
